module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-layout__drawer posit-drawer"
  }, [_c('header', {
    staticClass: "posit-drawer-header",
    staticStyle: {}
  }, [_c('img', {
    staticClass: "posit-avatar",
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "src": "/static/images/owl3.png"
    }
  }), _c('div', {
    staticClass: "posit-avatar-dropdown"
  }, [_c('span', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.user.first_name) + " " + _vm._s(_vm.user.last_name))]), _c('div', {
    staticClass: "mdl-layout-spacer"
  })])]), _c('nav', {
    staticClass: "posit-navigation mdl-navigation mdl-color--blue-grey-800"
  }, [_c('router-link', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "to": "start"
    }
  }, [_c('i', {
    staticClass: "mdl-color-text--blue-grey-400 material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("assignment")]), _vm._v("Registrering")]), _c('router-link', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "to": "activities"
    }
  }, [_c('i', {
    staticClass: "mdl-color-text--blue-grey-400 material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("event")]), _vm._v("Aktiviteter")]), _c('router-link', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "to": "statistics"
    }
  }, [_c('i', {
    staticClass: "mdl-color-text--blue-grey-400 material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("pie_chart")]), _vm._v("Statistik        ")]), _c('router-link', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "to": "administration"
    }
  }, [_c('i', {
    staticClass: "mdl-color-text--blue-grey-400 material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("settings")]), _vm._v("Administration")]), _c('div', {
    staticClass: "mdl-navigation__link",
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "mdl-color-text--blue-grey-400 material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("power_settings_new")]), _vm._v("Logga ut")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-571efc62","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MenuDrawer.vue
// module id = 522
// module chunks = 1